module.exports = __webpack_public_path__ + "bg-topo-candidato-laranja--5a0aa5ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./_source/img/themes/bg-topo-candidato-laranja.jpg
// module id = 5
// module chunks = 0